
import { Component, Mixins, Prop, Emit, } from "vue-property-decorator";
import { DomainRegistry } from "../../../../../domain";
import { ReceptionComment, } from "../../../../../domain/workflow/reception";
import { ReceptionCommentKinds, } from "../../../../../domain/workflow/kinds";
import { CommentDisplayMixin } from "./";

@Component
export default class CommentUpdaterMixin extends Mixins(CommentDisplayMixin) {
  @Prop()
  detailId: number;

  @Emit()
  commentUpdated(): void {}

  async registerComment(kind: ReceptionCommentKinds, comment: ReceptionComment): Promise<boolean> {
    const commentLabel = this.getCommentLabel(kind);
    try {
      const repository = DomainRegistry.workflow.getWorkflowRepository();
      const result = await repository.registerComment(this.detailId, kind, comment);
      if (result.success) {
        this.$success("成功", commentLabel + "の登録に成功しました。");
      } else {
        if (result.isCommentRegistrationFailure) {
          const latestComment = await this.getCommentByCommentId(result.commentId);
          const reeditResult = await this.reeditAndRegisterComment(kind, comment, latestComment);
          if (reeditResult) { return true; }
        }
        this.$error("エラー", commentLabel + "の登録に失敗しました。", result.reason);
        return false;
      }
      // 親に投げる
      this.commentUpdated();
      return true;
    } catch (e) {
      this.$error("エラー", commentLabel + "の登録に失敗しました。", e);
      return false;
    }
  }

  async getCommentByCommentId(commentId: number): Promise<ReceptionComment> {
    try {
      const repository = DomainRegistry.workflow.getWorkflowRepository();
      const result = await repository.getComment(commentId);
      return result;
    } catch (e) {
      this.$error("エラー", "コメントの取得に失敗しました。", e);
    }
  }

  async reeditAndRegisterComment(kind: ReceptionCommentKinds, editingComment: ReceptionComment, latestComment: ReceptionComment): Promise<boolean> {
    const editResult = await this.reeditComment(kind, editingComment.content, latestComment);
    if (editResult === undefined) {
      this.commentUpdated(); // コメント競合して登録中止したので最新のコメントセットを取得し直す
      return false;
    }

    const registerableReceptionComment = latestComment.clone();
    registerableReceptionComment.content = editResult;
    registerableReceptionComment.id = latestComment.deleted ? null : latestComment.id;
    registerableReceptionComment.archiveId = latestComment.deleted ? null : latestComment.archiveId;
    registerableReceptionComment.deleted = false;
    return this.registerComment(kind, registerableReceptionComment);
  }

  async reeditComment(kind: ReceptionCommentKinds, editingComment: string, latestComment: ReceptionComment): Promise<string> {
    return this.$commonDialogs.workflow.conflictCommentComparer.show(
      this.getCommentLabel(kind) + "再編集",
      this.getCommentLabel(kind),
      editingComment,
      latestComment
    );
  }

  async execDeleteComment(kind: ReceptionCommentKinds, comment: ReceptionComment): Promise<void> {
    const commentLabel = this.getCommentLabel(kind);
    try {
      const repository = DomainRegistry.workflow.getWorkflowRepository();
      const result = await repository.deleteComment(comment.id);
      if (result.success) {
        this.$success("成功", commentLabel + "の削除に成功しました。");
        // 親に投げる
        this.commentUpdated();
      } else {
        this.$error("エラー", commentLabel + "の削除に失敗しました。", result.reason);
      }
    } catch (e) {
      this.$error("エラー", commentLabel + "の削除に失敗しました。", e);
    }
  }
}
